module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/FooterYoutube.77d4e71e.svg";